export default __webpack_public_path__ + "static/9-process-improvement-be1e2f7c8e9d1dad1d6e8bba04fc3c24.jpeg";